import { noop } from 'lodash-es';
import { useSocket } from '../hooks/web/useWebsocket';

const notifySocket = {
  connect: noop,
  disconnect: noop,
};

export function initSocket(HandleNotifys) {
  const { connect, disconnect } = useSocket(HandleNotifys);
  connect();

  notifySocket.connect = connect;
  notifySocket.disconnect = disconnect;
}

export { notifySocket };
